import { atom } from "recoil"

export const migrateAccountDataState = atom({
  key: "atoms/account/migrateAccountDataState",
  default: true,
})
